import React, { Component } from "react";
import _ from "lodash";
// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles, ButtonGroup, InputLabel, ClickAwayListener, FormHelperText, TextField, Box, Tooltip, Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";

// Material components
import { Grid, Typography, Popper, Grow, MenuList, Paper, Button, Chip, Select, MenuItem, IconButton, CircularProgress } from "@material-ui/core";
import { Add, ArrowDropDown } from "@material-ui/icons";
import { fetchChatbotBubbles, updateChatbotBubbles } from "../../../../redux/actions/chatbotBubblesActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
// Shared components

// Component styles
import styles from "./styles";

// React router
import { withRouter } from "react-router-dom";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const initialState = { bubbles: [] };

const FILTER_OPTIONS = [{
  label:'Filter bubbles',
  index:0, 
  name:['Public', 'Private', 'Both']
},{
  label:'Show Private Bubbles',
  index:1, 
  name:['Private', 'Both']
},{
  label: 'Show Public Bubbles',
  index: 2, 
  name:['Public', 'Both']
},{
  label: 'Show All Bubbles',
  index: 3, 
  name:['Public', 'Private', 'Both']
}];

class CreateBubble extends Component {
  state = {
    edit: false,
    index: undefined,
    bubbles: [],
    openForm: false,
    openFilter: false,
    name: "",
    type: "",
    environment: "",
    utterance: "",
    avatar: "",
    loading: true,
    hasParent: false, 
    filterIndex: 0
  };

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
    this.anchorRef = React.createRef();
  }

  fetchData = () => {
    this.props.fetchChatbotBubbles().then(() => {
      if (this.mounted) {
        this.setState({
          bubbles: _.get(this.props, "bubbles.bubbles", []),
          loading: false
        });
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.bubbles !== this.props.bubbles && this.props.bubbles && this.props.bubbles.status !== "success") {
      this.props.pushMessage({
        message: "Error occurred while trying to fetch bubbles!",
        type: "error"
      });
    }
    if (
      prevProps.updateResponse !== this.props.updateResponse &&
      this.props.updateResponse &&
      this.props.updateResponse.status !== "success"
    ) {
      this.props.pushMessage({
        message: "Error occurred while trying to update bubbles!",
        type: "error"
      });
    }
    if (
      prevProps.updateResponse !== this.props.updateResponse &&
      this.props.updateResponse &&
      this.props.updateResponse.status === "success"
    ) {
      this.props.pushMessage({
        message: "Bubble changes saved successfully!",
        type: "success"
      });
    }
  }

  handleDelete = () => {
    this.setState(initialState);
  };

  inputHandler = (field, value) => {
    const newState = { ...this.state };
    if (field === "type" && value === "intent") newState["utterance"] = "";
    newState[field] = value;
    this.setState(newState);
  };

  openForm = (index, environment) => {
    console.log("open form");
    this.setState({
      openForm: index,
      edit: false,
      name: "",
      type: "",
      environment: environment??"",
      utterance: "",
      avatar: "",
      hasParent: environment?true:false
    });
  };

  closeForm = () => {
    const newState = { ...this.state };
    newState["name"] = "";
    newState["type"] = "";
    newState["utterance"] = "";
    newState["environment"] = "";
    newState["avatar"] = "";
    newState["openForm"] = false; 
    this.setState(newState);
  };

  renderAddChildBubble = (bubble, path=[]) => {
    const text = bubble.name ?? "";
    return <Tooltip placement="right" title={`Add ${text} child bubble`} aria-label={`Add ${text} child bubble`}>
    <IconButton className={this.props.classes.addButton} onClick={() => this.openForm(path, bubble.environment)} color="primary">
    <Add /></IconButton></Tooltip>;
  }

  deleteBubble(path, index) {
    const newState = { ...this.state };
    if (path) {
      _.get(newState.bubbles, path).splice(index, 1);
    } else {
      _.get(newState, "bubbles").splice(index, 1);
    }
    this.setState(newState);
    this.props.updateChatbotBubbles(newState.bubbles);
  }

  renderBubble = (bubbles, child, layer, deletePath) => {
    
    return (
      <div>
        {bubbles.filter(bubble => FILTER_OPTIONS[this.state.filterIndex].name.includes(bubble.environment)).map((bubble, index) => {
          const newDeletePath = deletePath + `[${index}].children`;
          const fullPath = `${deletePath}[${index}].`;
          return (
            <Box className={!child&&this.props.classes.bubblesWrapper} ml={layer + 1}>
            {!child&&<div className={this.props.classes.bubblesEnvironment}>{bubble.environment}</div>}
            <div key={index} className={this.props.classes.levelContainer}>
                <Tooltip
                  placement="right"
                  title={`Name: ${bubble.name}, Type: ${bubble.type}, Utterance: ${bubble.utterance ?? "Not a utterance bubble"}, Environment: ${
                  bubble.environment != null ? bubble.environment : "Both"
                  }`}
                >
                  <Chip
                    label={bubble.name}
                    className={child ? this.props.classes.childBubble : this.props.classes.parentBubble}
                    onClick={() => {
                      this.setState({
                        openForm: deletePath,
                        index,
                        edit: true,
                        name: bubble.name,
                        type: bubble.type,
                        environment: bubble.environment,
                        utterance: bubble.utterance,
                        avatar: bubble.avatar,
                        hasParent: child
                      });
                    }}
                    onDelete={() => this.deleteBubble(deletePath, index)}
                  />
                </Tooltip>
              {bubble.type === "hierarchy" ? (
                <>
                  {this.renderAddChildBubble(bubble, fullPath)}
                  {this.renderBubble(bubble.children, true, layer + 1, newDeletePath)}
                </>
              ) : null}
            </div>
            </Box>

          );
        })}
      </div>
    );
  };

  addBubble = path => {
    const newState = { ...this.state };
    const avatar = this.state.avatar !== "" ? this.state.avatar : " ";
    if (path.constructor === String) {
      if (this.state.type === "intent") {
        _.get(newState.bubbles, path + "children", []).push({
          name: this.state.name,
          type: this.state.type,
          utterance: this.state.utterance,
          avatar: avatar,
          environment: this.state.environment != null ? this.state.environment : "Both",
          children: []
        });
      } else {
        _.get(newState.bubbles, path + "children", []).push({
          name: this.state.name,
          type: this.state.type,
          avatar: avatar,
          environment: this.state.environment != null ? this.state.environment : "Both",
          children: []
        });
      }
    } else {
      if (this.state.type === "intent") {
        newState["bubbles"].push({
          name: this.state.name,
          type: this.state.type,
          utterance: this.state.utterance,
          avatar: avatar,
          environment: this.state.environment != null ? this.state.environment : "Both",
          children: []
        });
      } else {
        newState["bubbles"].push({
          name: this.state.name,
          type: this.state.type,
          avatar: avatar,
          environment: this.state.environment != null ? this.state.environment : "Both",
          children: []
        });
      }
    }

    this.setState(newState);
    this.closeForm();
  };

  saveBubbleChanges = async () => {
    const newState = { ...this.state };
   /*  debugger; */
    const updatedBubble = _.get(
      newState.bubbles,
      newState.openForm ? newState.openForm + `[${newState.index}]` : `[${newState.index}]`
     );
    if (updatedBubble.type !== newState.type && newState.type === "intent") {
      for (let i = 0; i < updatedBubble.children.length; i++) {
        newState["bubbles"].push(updatedBubble.children[i]);
      }
      updatedBubble["children"] = [];
    }
    updatedBubble["name"] = newState.name;
    updatedBubble["type"] = newState.type;
    updatedBubble["utterance"] = newState.utterance;
    updatedBubble["avatar"] = newState.avatar;
    updatedBubble["environment"] = newState.environment != null ? newState.environment : "Both";
    await this.props.updateChatbotBubbles(this.state.bubbles).then(() => {
      this.setState(newState); 
    });
  };

  checkValidity = (name, type, environment, utterance) => {
    if (name !== "" && type !== "" && environment !== "") {
      if (type === "intent" && utterance === "") return true;
      return false;
    } else {
      return true;
    }
  }


   /* filter */

  handleClick = () => {
    this.setState(prevState =>{ return{filterOpen: !prevState.filterOpen}});
  };

  handleMenuItemClick = (event, index) => {
    this.setState({
      filterIndex: index,
      filterOpen: false
    });
  };

  handleToggle = () => {
    this.setState(prevState =>{ return{filterOpen: !prevState.filterOpen}});
  };

  handleClose = (event) => {
    if (this.anchorRef.current && this.anchorRef.current.contains(event.target)) {
      return;
    }
    this.setState({filterOpen: false});
  };

  

  render() {
    const { classes, selectedConnection } = this.props;
    const { name, type, environment, utterance, loading, edit, options, filterOpen, filterIndex, bubbles } = this.state;
    const types = ["intent", "hierarchy"],
    environments = ["Private", "Public", "Both"];
    

    const disabled = this.checkValidity(name, type, environment, utterance);
    if (!loading) {
      return (
        <div>
          <Box className={classes.contentTitle}>
            <Typography variant="h4" component="h4">
              Configure AI Assistant Bubbles
            </Typography>
            <div style={{display: "flex", alignItems: "center"}}>
              <ButtonGroup className={classes.filterButton} variant="outlined"
               color="primary" ref={this.anchorRef} aria-label="split button">
                <Button size="small" onClick={this.handleClick}>{FILTER_OPTIONS[filterIndex].label}</Button>
                  <Button
                    size="small"
                    color="primary"
                    aria-controls={filterOpen ? 'split-button-menu' : undefined}
                    aria-expanded={filterOpen ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={this.handleToggle}
                  >
                  <ArrowDropDown />
                </Button>
              </ButtonGroup>
                <Popper style={{zIndex:111}} open={filterOpen} anchorEl={this.anchorRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                        <Paper>
                          <ClickAwayListener onClickAway={this.handleClose}>
                            <MenuList id="split-button-menu">
                              {FILTER_OPTIONS.map((option, index) => (
                                <MenuItem
                                  key={option.name}
                                  disabled={index === 0}
                                  selected={index === filterIndex}
                                  onClick={(event) => this.handleMenuItemClick(event, index)}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                    </Grow>
                  )}
                </Popper>
              <Button size="small" onClick={() => this.openForm([])} variant="contained" color="primary"><Add />Create New Bubble</Button>
            </div>
          </Box>
            <Box className={classes.tabInnerContent}>
              <div className={classes.row}>
                {this.renderBubble(this.state.bubbles, false, 0, "")}
              </div>
            </Box>
            <Dialog open={this.state.openForm || this.state.openForm === ""}>
              <DialogTitle>
                <Typography variant="h5">
                  Bubble Settings
                </Typography> 
              </DialogTitle>
              <DialogContent dividers>
                <InputLabel id="bubbleType" className={classes.formLabel}>
                  Bubble Label
                </InputLabel>
                <TextField
                  className={classes.bubbleInput}
                  placeholder="Enter Bubble Label"
                  required
                  variant="outlined"
                  id="bubbleName"
                  multiline={true}
                  name="bubbleName"
                  value={name}
                  onChange={event => {
                    this.inputHandler("name", event.target.value);
                  }}
                  InputProps={{ className: classes.textField }}
                />
                <InputLabel id="bubbleType" className={classes.formLabel}>
                  Bubble Type
                </InputLabel>
                <Select
                  className={classes.bubbleInput}
                  variant="outlined"
                  value={type}
                  placeholder="Type"
                  id="bubbleType"
                  label="Select bubble type"
                  onChange={event => this.inputHandler("type", event.target.value)}
                  >
                    <MenuItem key={0} value="">
                      <em>None</em>
                    </MenuItem>
                    {_.map(types, (type, i) => (
                      <MenuItem key={++i} value={type}>
                        {type}
                    </MenuItem>
                    ))}
                </Select>
                {this.state.type === "intent" ? (
                  <>
                    <InputLabel id="utterance" className={classes.formLabel}>
                      Utterance
                    </InputLabel>
                    <TextField
                      className={classes.bubbleInput}
                      placeholder="Utterance*"
                      required
                      variant="outlined"
                      id="utterance"
                      multiline={true}
                      name="utterance"
                      value={this.state.utterance}
                      color="primary"
                      helperText="Utterance that will appear after bubble click"
                      onChange={event => {
                        this.inputHandler("utterance", event.target.value);
                      }}
                      InputProps={{ className: classes.textField }}
                    />
                  </>
                ) : null}
                 
                <InputLabel id="Avatar" className={classes.formLabel}>
                  Avatar Image URL
                </InputLabel>
                <TextField
                  className={classes.bubbleInput}
                  placeholder="Image URL"
                  variant="outlined"
                  id="Avatar"
                  multiline={true}
                  name="Avatar"
                  value={this.state.avatar}
                  color="primary"
                  helperText="Avatar image that will appear inside of the bubble"
                  onChange={event => {
                    this.inputHandler("avatar", event.target.value);
                  }}
                  InputProps={{ className: classes.textField }}
                />
                
                {!this.state.hasParent&&
                <>
                <InputLabel id="EnvironmentLab" className={classes.formLabel}>
                  Bubble Environment
                </InputLabel>
                  <Select
                    className={classes.bubbleInput}
                    id="environment"
                    value={environment}
                    variant="outlined"
                    placeholder="Environment"
                    helperText="Select who should have access to the bubble"
                    onChange={event => this.inputHandler("environment", event.target.value)}
                  >
                    <MenuItem key={0} value="">
                      <em>None</em>
                    </MenuItem>
                    {_.map(environments, (environment, i) => (
                      <MenuItem key={++i} value={environment}>
                        {environment}
                      </MenuItem>
                    ))}
                  </Select>
                </>
                }
                </DialogContent>
                <DialogActions>
                  
                  <Button
                      onClick={() => {
                        this.setState({ openForm: false });
                      }}
                    >
                      Cancel
                  </Button>
                    {edit ? (
                    <Button disabled={disabled} onClick={this.saveBubbleChanges}>
                        Save changes
                    </Button>
                    ) : (
                    <Button
                        disabled={disabled}
                        onClick={() => {
                          this.addBubble(this.state.openForm);
                        }}
                      >
                        Add bubble
                    </Button>
                    )}
                </DialogActions>
              </Dialog>
              <div className={classes.tabContentActions}>
                <Button disabled={!bubbles.length>0&&true} variant="contained" size="large" color="primary" onClick={() => this.props.updateChatbotBubbles(this.state.bubbles)}>Save Changes</Button>
              </div>
        </div>
      );
    } else {
      return <Box className={classes.contentTitle}><CircularProgress /></Box>;
    }
  }
}

CreateBubble.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    bubbles: state.chatbotSettings.bubbles,
    updateResponse: state.chatbotSettings.updateResponse
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchChatbotBubbles,
        updateChatbotBubbles,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(CreateBubble))
);
